import { Tooltip } from 'antd';

import { InfoCircleFilled } from '@ant-design/icons';

import { TextNorlys } from '~src/components/Text';
import { ThumbnailWithUrl } from '~src/components/ThumbnailWithUrl';
import { formatTooltipOverlay } from '~src/util/tooltip';

import { Body, ImageWrapper, InfoContainer, InfoRow } from '../../style';
import { ProductContentCommonProps } from '../../types';

export const ProductContentCommonNorlys = ({
  selected,
  height,
  imageUrl,
  flipped,
  infoRows,
}: ProductContentCommonProps) => {
  const textColor = selected ? 'white' : 'black';

  if (!flipped) {
    return (
      <Body>
        <ImageWrapper>
          <ThumbnailWithUrl height={height} imageUrl={imageUrl} />
        </ImageWrapper>
      </Body>
    );
  }

  return (
    <Body>
      <InfoContainer {...{ height }}>
        {infoRows?.map(({ label, value, tooltip }) => (
          <InfoRow key={label}>
            <TextNorlys fontType='heading' color={textColor}>
              {label}
              {tooltip && (
                <Tooltip placement='right' overlay={formatTooltipOverlay(tooltip)}>
                  &nbsp;
                  <InfoCircleFilled />
                </Tooltip>
              )}
            </TextNorlys>

            <TextNorlys color={textColor}>{value}</TextNorlys>
          </InfoRow>
        ))}
      </InfoContainer>
    </Body>
  );
};
